import {
  BrowserModule,
  BrowserTransferStateModule,
} from '@angular/platform-browser';
import {
  NgModule,
  Inject,
  PLATFORM_ID,
  Optional,
  Injector,
} from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { BannerFormComponent } from './banner-form/banner-form.component';
import { MenuFormComponent }from './menu-form/menu-bar-form.component';
import { TrackingModule } from './tracking/tracking.module';
import { LanguageComponent } from './language/language.component';
import { ReRouteComponent } from './re-route/re-route.component';

import { APP_BASE_HREF, isPlatformServer } from '@angular/common';
import { SearchFormLoadingComponent } from './search-form/search-form-loading/search-form-loading.component';

import { REQUEST } from '@nguniversal/express-engine/tokens';
import { TranslateService } from '@ngx-translate/core';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TrackingItemRefundCodDialog } from '../app/tracking/tracking-item/tracking-item-refund/tracking-item-refund-cod-dialog/tracking-item-refund-cod-dialog';
import { TrackingItemRefundCodPdfPreview } from '../app/tracking/tracking-item/tracking-item-refund/tracking-item-refund-cod-preview/tracking-item-refund-cod-preview';
@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'KeTrackTrace2' }),
    BrowserAnimationsModule,

    // core & shared
    CoreModule,
    SharedModule,
    // app
    AppRoutingModule,
    TrackingModule,
    BrowserModule,
  ],
  declarations: [
    AppComponent,
    SearchFormComponent,
    BannerFormComponent,
    TrackingItemRefundCodDialog,
    TrackingItemRefundCodPdfPreview,

    MenuFormComponent,
    HomeComponent,
    LanguageComponent,
    ReRouteComponent,
    SearchFormLoadingComponent
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule {}
